import { render } from "./product.vue?vue&type=template&id=273dcd10&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=273dcd10&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/pre__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273dcd10"]])

export default __exports__